var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.groups.length > 1)?_c('app-tabs',{staticClass:"no-scrollbar",class:_vm.$style.groups,attrs:{"slug":"group","items":_vm.groups,"formatter":function (group) { return group.title[_vm.$i18n.locale]; }}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }